import WebsiteLayout from '../../../components/LandingPageWrapper'
import Contact from '../../../components/LandingPage/Contact'

const ContactPage = () => {
  return (
    <WebsiteLayout>
      <Contact />
    </WebsiteLayout>
  )
}

export default ContactPage
